import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useDependencies } from '@servicetitan/react-ioc';

import { MidCallCheckInBanner } from './mid-call-checkin-banner';
import * as Styles from './mid-call-checkin-banner.module.less';
import { Breadcrumbs } from '../../common/components/breadcrumbs/breadcrumbs';
import { MainStore } from '../../common/stores/main.store';

/*
 * Topic-picker sub-header: the breadcrumb job-title strip, with a full-width "Mid-Call Check-In
 * available" banner that animates in to replace it when a mid-call (halftime) report exists for the
 * appointment. Tapping the banner opens the mid-call coaching chat. When not available the banner
 * is hidden and only the breadcrumbs show.
 */
export const TopicPickerSubHeader: FC<{ coachingLive: boolean }> = observer(({ coachingLive }) => {
    const [mainStore] = useDependencies<[MainStore]>(MainStore);
    const history = useHistory();

    const openMidCall = useCallback(() => {
        history.push(
            `/topic/field-pro/mid-call/${mainStore.selectedAppointment?.id}/questions?fromInApp=1`
        );
    }, [history, mainStore.selectedAppointment?.id]);

    return (
        <div className={Styles.subHeader}>
            <Breadcrumbs />
            <MidCallCheckInBanner open={coachingLive} onClick={openMidCall} />
        </div>
    );
});
